module.exports = __webpack_public_path__ + "static/headphones-lady-mobile-130179a95f48bf9836c38d933831de73.jpg";